//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'EPDS',
  data () {
    return {
      form: {
        data1: '',
        data2: '',
        data3: '',
        data4: '',
        data5: '',
        data6: '',
        data7: '',
        data8: '',
        data9: '',
        data10: ''
      },
      dataList1: [
        {name: '跟以前一样', value: '0'},
        {name: '比以前有所减少', value: '1'},
        {name: '明显减少', value: '2'},
        {name: '完全不能', value: '3'}
      ],
      dataList2: [
        {name: '跟以前一样', value: '0'},
        {name: '比以前有所减少', value: '1'},
        {name: '明显减少', value: '2'},
        {name: '完全没有', value: '3'}
      ],
      dataList3: [
        {name: '跟以前一样', value: '0'},
        {name: '比以前增多', value: '1'},
        {name: '有时发生', value: '2'},
        {name: '大部分时候是这样', value: '3'}
      ]
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      let result = 0
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
            result += form[key]
          }
        }
      }
      if (!flag) {
        return ''
      }
      return String(result)
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/EPDS.vue